<!-- 消防设备弹窗 -->
<template>
  <el-dialog v-dialogDrag title="消防设备信息" :close-on-click-modal="false" :visible.sync="dialogVisible" class="xfboxdialog">
    <el-tabs v-model="activeName1" @tab-click="handleClick1">
      <el-tab-pane name="1">
        <span slot="label">正常<em>{{nav.normal}}</em></span>
        <!-- <div class="dialogcontent">临期</div> -->
      </el-tab-pane>
      <el-tab-pane name="0">
        <span slot="label">临期<em>{{nav.lq}}</em></span>
        <!-- <div class="dialogcontent">过期</div> -->
      </el-tab-pane>
      <el-tab-pane name="3">
        <span slot="label">未及时保养<em>{{nav.overOps}}</em></span>
        <!-- <div class="dialogcontent">未及时保养</div> -->
      </el-tab-pane>
      <el-tab-pane name="2">
        <span slot="label">过期<em>{{nav.overTime}}</em></span>
        <!-- <div class="dialogcontent">正常</div> -->
      </el-tab-pane>
    </el-tabs>

    <div class="dialogcontent">
      <div class="left">
        <li @click="indextab = item.id; getinfo( item.id)" v-for="(item,i) in tableData" :key='i' :class="indextab==item.id?'active':''">{{item.devName}}</li>
      </div>
      <div class="right">
        <el-tabs v-model="activeName2" >
          <el-tab-pane label="基本信息" name="first">
            <div class="img">
              <h3>{{formData.safeFighting.devName}}</h3>

              <p v-if="!swiperData.length" style="text-align: center;margin-top: 4rem;font-size: 3em;">暂无图片</p>
              <div v-show="swiperData.length"  >

            
                <!-- swiper1 -->
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                  <swiper-slide v-for="(item,index) in swiperData" :key="index">
                    <img :src="item.url">
                  </swiper-slide>
                  <div class="swiper-button-next swiper-button-black" slot="button-next"></div>
                  <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div>
                </swiper>
                <!-- swiper2 Thumbs -->
                <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                  <swiper-slide v-for="(item,index) in swiperData" :key="index">
                    <img :src="item.url">
                  </swiper-slide>
                </swiper>
               </div>



            </div>
            <div class="form">
              <div class="item"><label>设备名称:</label><span>{{formData.safeFighting.devName}}</span></div>
              <div class="item"><label>设备品牌:</label><span>{{formData.safeFighting.devBrand}}</span></div>
              <div class="item"><label>设备类型:</label><span>{{formData.safeFighting.model}}</span></div>
              <div class="item"><label>安装区域:</label><span>{{formData.safeFighting.area}}</span></div>
              <div class="item"><label>负责人:</label><span>{{formData.safeFighting.linkUser}}</span></div>
              <div class="item"><label>生产日期:</label><span>{{formData.safeFighting.produceDate?new Date(formData.safeFighting.produceDate).Format("yyyy-MM-dd"):''}}</span></div>
              <div class="item"><label>安装日期:</label><span>{{formData.safeFighting.installDate?new Date(formData.safeFighting.installDate).Format("yyyy-MM-dd"):''}}</span></div>
              <div class="item"><label>售后截止:</label><span>{{formData.safeFighting.byDate?new Date(formData.safeFighting.byDate).Format("yyyy-MM-dd"):'' }}</span></div>
              <div class="item"><label>生产厂商:</label><span>{{formData.safeFighting.customName}}</span></div>
              <div class="item"><label>使用状态:</label><span>{{formData.safeFighting.useStatus===0?"未正常使用":"正常使用"}}</span></div>
              <div class="item"><label>保养周期:</label><span>{{formData.safeFighting.maintain}}</span></div>
              <div class="item"><label>维保单位:</label><span>{{formData.safeFighting.maintainCompany}}</span></div>
              <div class="item"><label>当前状态:</label>
                <span v-if="formData.safeFighting.status===0">临期</span>
                <span v-if="formData.safeFighting.status===1">正常</span>
                <span v-if="formData.safeFighting.status===2">过期</span>
                <span v-if="formData.safeFighting.status===3">未及时保养</span>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="运维记录" name="second">
            <table class="mytable">
              <thead>
                <tr>
                  <td>日期</td>
                  <td>维保类型</td>
                  <td>维保单位</td>
                  <td>维保人员</td>
                  <td>维保结果</td>
                  <td>备注</td>
                </tr>
              </thead>
              <tbody>
                <p v-if="!formData.safeOps" style="text-align: center;margin-top: 1rem;">暂无数据</p>

                <tr v-for="(item,i) in formData.safeOps" :key='i'>
                  <td>{{item.opsDate}}</td>
                  <td>{{item.opsType}}</td>
                  <td>{{item.opsCompany}}</td>
                  <td>{{item.opsUser}}</td>
                  <td>{{item.opsResult}}</td>
                  <td>{{item.remark}}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
          <el-tab-pane label="关联表计" name="third">
            <table class="mytable">
              <thead>
                <tr>
                  <td>表计类型</td>
                  <td>表计编号</td>
                  <td>表计名称</td>
                </tr>
              </thead>
              <tbody>
                <p v-if="!formData.safeIotRelation" style="text-align: center;margin-top: 1rem;">暂无数据</p>
                
                <tr v-for="(item,i) in formData.safeIotRelation" :key='i'>
                  <td>{{item.iotType}}</td>
                  <td>{{item.iotNum}}</td>
                  <td>{{item.iotName}}</td>
                </tr>
              </tbody>
            </table>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>

  </el-dialog>

</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import api from '@/apis/safety/firecontrol'
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      dialogVisible: false,
      activeName1: '1',
      activeName2: 'first',  
      tableData: [],   
      indextab:'',
      nav:{}, 
      formData: {
        //消防设备
        safeFighting: {

        },
        //表计关联
        safeIotRelation: [

        ],
        //运维记录
        safeOps: [

        ],
      },
      status:1,


      //swiper数据
      swiperData:[],//swipe图片数据
      swiperOptionTop: {
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: false,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        // watchSlidesVisibility: true,/*避免出现bug*/
      },


    }
  },
  methods: {
    openDialog(){
      this.dialogVisible = true
    },
    //状态列表
    handleClick1(tab) {
      this.status =  tab.name
      this.getlist()
    },





    getlist(){
      api
        .list({
          params: {
            limit: 100,
            page: 1,
            status: this.status,
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            this.tableData = res.data.list
            if (this.tableData.length) {
              this.indextab = this.tableData[0].id
              this.getinfo(this.indextab) 
              this.activeName2='first'
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },

    getinfo(id){
      api
        .info({
          params: {
            id
          },
        })
        .then((res) => {
          if (res.code === 10000) {
            this.formData =  res.data
            this.activeName2='first'
            if (this.formData.safeFighting.pictures) {
              this.swiperData = JSON.parse(this.formData.safeFighting.pictures)
            }else{
              this.swiperData = []
            }
            if (this.$refs.swiperTop) {
              //swiper画图 联动
              this.$nextTick(()=>{
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
                swiperThumbs.controller.control = swiperTop
              })
            }

          } else {
            this.$message.error(res.message)
          }
        })      
    }
  },
  mounted() {


    api
      .firecontrol({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.nav = res.data
          //{ value: data.normal, name: '正常' },
          //{ value: data.lq, name: '临期' },
          //{ value: data.overTime, name: '过期' },
          //{ value: data.overOps, name: '未及时保养' },
        } else {
          this.$message.error(res.message)
        }
      })
    this.getlist();


  },
}
</script>

<style lang="less" scoped>
// .wlwboxdialog .el-dialog
.xfboxdialog 

 /deep/ .el-dialog {
  width: 65rem;
  .el-tabs__nav-wrap::after {
    background-color: #3570ff;
  }
  .el-tabs__active-bar {
    background-color: #24ffb1;
    height: 4px;
  }
  .el-tabs--top .el-tabs__item {
    font-size: 0.8rem;
    height: 2rem;
    line-height: 2rem;
  }
  .el-tabs--top .el-tabs__item.is-active {
    color: #24ffb1;
  }
  em {
    font-style: normal;
    background: #ff5f8c;
    color: #fff;
    border-radius: 20px;
    padding: 0 10px 4px;
    font-size: 0.6rem;
    margin-left: 10px;
  }
  #tab-zc em {
    background: #3570ff;
  }
  .dialogcontent {
    display: flex;
    flex-direction: row;
    padding: 0.5rem;
    height: 35rem;
    overflow: hidden;
    .left {
      width: 13rem;
      flex-shrink: 0;
      border: #3570ff solid 1px;
      padding: 0.5rem;
      margin-right: 1rem;
      height: 100%; font-size: .7rem;
      overflow-y: auto;
      li {
        height: 1.8rem;
        color: #fff;
        padding: 0 0.5rem;
        line-height: 1.8rem;
        cursor: pointer;
        margin-bottom: 0.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      li.active {
        color: #24ffb1;
        background: rgba(24, 255, 106, 0.1);
        border: #24ffb1 dashed 1px;
      }
      li:hover {
        color: #24ffb1;
      }
    }
    .right {
      flex: 1;
      width: 100%;
      overflow: hidden;
      display: flex; font-size: .8rem;
      flex-direction: column;
      .el-tab-pane {
        height: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        align-items: baseline;
      }
      .img {
        width: 22rem;
        margin-right: 1rem;
        flex-shrink: 0;
        h3 {
          font-size: 0.8rem;
          color: #24ffb1;
        }
        .gallery-top{ border: #3570ff solid 1px; width: 100%; height: 700px; margin-top: .5rem;
          .swiper-wrapper{
            .swiper-slide{ display: flex; align-items: center; justify-content: center;}
          }
          img{ max-width: 100%; max-height: 100%;}
        }
        .gallery-thumbs{ margin-top: 10px;
          .swiper-wrapper{ display: flex; flex-direction: row; justify-content: center; align-items: center; 
            .swiper-slide{ border: #3570ff solid 1px; display: flex; align-items: center; justify-content: center; width: 19%; height: 140px; opacity: .6;
              img{ max-width: 100%; max-height: 100%;}
            }
            .swiper-slide-active{ opacity: 1;}
          }
        }


        
      }
      .form {
        flex: 1;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        .item {
          border-bottom: #555e86 dashed 1px;
          padding: 0.4rem 0.5rem;
          display: flex; font-size: .7rem;
          flex-direction: row;
          label {
            width: 5rem;
            flex-shrink: 0;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 10px;
          }
          span {
            color: #fff;
          }
        }
        .item:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>